import { useEffect } from 'react'

export const usePageTitle = (title?: string) => {
  const defaultTitle = 'Quarter20'

  useEffect(() => {
    document.title = title || defaultTitle
  }, [title])
}
